import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/make-booking/$id/bus-details/$transportationId/date',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
